import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { GlobalFormTemplateVersion } from '@models/global-forms';
import { Repo } from '@repos/repo.service';

export interface GlobalFormsVersionParams {
	globalFormId: string;
}

@Injectable({
	providedIn: 'root',
})
export class GlobalFormsVersionsRepo extends Repo<
	GlobalFormTemplateVersion,
	unknown
> {
	GetCollectionPath(params: GlobalFormsVersionParams): string {
		return CollectionPaths.global_forms_versions(params.globalFormId);
	}

	constructor(firestore: AngularFirestore) {
		super(firestore);
	}
}
